<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-paper-container">
      <div class="orangehrm-header-container">
        <oxd-text tag="h6" class="orangehrm-main-title">
          {{ $t('F940, W2 and W3 Forms for ') }} {{ thisYear }}
        </oxd-text>
      </div>
      <div class="orangehrm-header-container">
        <oxd-button
          :label="$t('Download Form 944')"
          display-type="secondary"
          @click="onClickDownloadf944"
        />
        <oxd-button
          :label="$t('Download Form 940 (FUTA)')"
          display-type="secondary"
          @click="onClickDownloadF940"
        />
        <oxd-button
          :label="$t('Download Form W3')"
          display-type="secondary"
          @click="onClickDownloadW3"
        />
      </div>
      <table-header :total="total" :loading="isLoading"></table-header>
      <div class="orangehrm-container">
        <oxd-card-table
          :loading="isLoading"
          :headers="headers"
          :items="items?.data"
          row-decorator="oxd-table-decorator-card"
        />
      </div>
      <div class="orangehrm-bottom-container">
        <oxd-pagination
          v-if="showPaginator"
          v-model:current="currentPage"
          :length="pages"
        />
      </div>
      <div class="orangehrm-bottom-container">
        <oxd-pagination
          v-if="showPaginator"
          v-model:current="currentPage"
          :length="pages"
        />
        <oxd-text tag="h2" class="orangehrm-main-title">
          Total Amount: ${{ totalCostSum.toFixed(2) }}
        </oxd-text>
      </div>
    </div>
  </div>
</template>

<script>
import usePaginate from '@ohrm/core/util/composable/usePaginate';
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';

function aggregateGrossPay(data) {
  const aggregation = data.reduce((acc, {empNumber, grossPay}) => {
    if (acc[empNumber]) {
      acc[empNumber] += parseFloat(grossPay);
    } else {
      acc[empNumber] = parseFloat(grossPay);
    }
    return acc;
  }, {});

  return aggregation;
}

export default {
  setup() {
    const http = new APIService(window.appGlobal.baseUrl, '/api/v2/pim/f944');
    const http1 = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/pim/deductions',
    );
    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http);
    return {
      http,
      http1,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      execQuery,
      items: response,
    };
  },
  data() {
    return {
      thisYear: null,
      headers: [
        {
          name: 'ssn',
          slot: 'title',
          title: this.$t('SSN'),
          style: {'flex-basis': '80%'},
        },
        {
          name: 'firstName',
          slot: 'title',
          title: this.$t('general.first_name'),
          style: {'flex-basis': '80%'},
        },
        {
          name: 'lastName',
          slot: 'title',
          title: this.$t('general.last_name'),
          style: {'flex-basis': '80%'},
        },
        {
          name: 'quarterGross',
          slot: 'title',
          title: this.$t('pim.gross_pay'),
          style: {'flex-basis': '80%'},
        },
        {
          name: 'actions',
          slot: 'action',
          title: this.$t('W2'),
          style: {'flex-shrink': 1},
          cellType: 'oxd-table-cell-actions',
          cellConfig: {
            view: {
              onClick: this.onClickDownloadW2,
              props: {
                name: 'download',
              },
            },
          },
        },
      ],
    };
  },
  created() {
    this.getTaxYear();
  },
  computed: {
    totalCostSum() {
      if (!Array.isArray(this.items?.data)) return 0;
      return this.items.meta.qtotal || 0;
    },
  },
  methods: {
    async getTaxYear() {
      this.isLoading = true;
      this.http1.http
        .get('/api/v2/pim/deductions')
        .then((response) => {
          const {data} = response.data;
          this.thisYear = data.taxyear;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClickDownloadW3() {
      const dash = '';
      const pdf = '.pdf';
      const d = new Date();
      let year = this.thisYear;
      const fn = 'fw3for';
      const fl = fn.concat(year, dash, pdf);
      const emp = '1';
      const str1 = '/api/v2/pim/employees/';
      const str2 = '/screen/personal/attachments';
      const str = str1.concat(emp, str2);
      const sfiles = new APIService(window.appGlobal.baseUrl, str);
      sfiles.getAll().then((response) => {
        let dat = response.data;
        const fle = dat.data.find((f) => f.filename === fl);
        if (fle) {
          //console.log(fle);
          let id = fle.id;
          const downUrl = `${window.appGlobal.baseUrl}/pim/viewAttachment/empNumber/1/attachId/${id}`;
          window.open(downUrl, '_blank');
        }
      });
    },
    onClickDownloadW2(item) {
      const dash = '-';
      const pdf = '.pdf';
      const d = new Date();
      let year = this.thisYear;
      const fn = 'fw2for';
      const fl = fn.concat(year, dash, item.firstName, item.lastName, pdf);
      const emp = '1';
      const str1 = '/api/v2/pim/employees/';
      const str2 = '/screen/personal/attachments';
      const str = str1.concat(emp, str2);
      const sfiles = new APIService(window.appGlobal.baseUrl, str);
      console.log(fl);
      sfiles.getAll().then((response) => {
        let dat = response.data;
        const fle = dat.data.find((f) => f.filename === fl);
        if (fle) {
          let id = fle.id;
          const downUrl = `${window.appGlobal.baseUrl}/pim/viewAttachment/empNumber/1/attachId/${id}`;
          window.open(downUrl, '_blank');
        }
      });
    },
    onClickDownloadF940() {
      const dash = '';
      const pdf = '.pdf';
      const d = new Date();
      let year = this.thisYear;
      const fn = 'f940for';
      const fl = fn.concat(year, dash, pdf);
      const emp = '1';
      const str1 = '/api/v2/pim/employees/';
      const str2 = '/screen/personal/attachments';
      const str = str1.concat(emp, str2);
      const sfiles = new APIService(window.appGlobal.baseUrl, str);
      sfiles.getAll().then((response) => {
        let dat = response.data;
        const fle = dat.data.find((f) => f.filename === fl);
        if (fle) {
          //console.log(fle);
          let id = fle.id;
          const downUrl = `${window.appGlobal.baseUrl}/pim/viewAttachment/empNumber/1/attachId/${id}`;
          window.open(downUrl, '_blank');
        }
      });
    },
    onClickDownloadf944() {
      const dash = '';
      const pdf = '.pdf';
      const d = new Date();
      let year = this.thisYear;
      const fn = 'f944for';
      const fl = fn.concat(year, dash, pdf);
      const emp = '1';
      const str1 = '/api/v2/pim/employees/';
      const str2 = '/screen/personal/attachments';
      const str = str1.concat(emp, str2);
      const sfiles = new APIService(window.appGlobal.baseUrl, str);
      sfiles.getAll().then((response) => {
        let dat = response.data;
        const fle = dat.data.find((f) => f.filename === fl);
        if (fle) {
          //console.log(fle);
          let id = fle.id;
          const downUrl = `${window.appGlobal.baseUrl}/pim/viewAttachment/empNumber/1/attachId/${id}`;
          window.open(downUrl, '_blank');
        }
      });
    },
    onClickDownloadf1120s() {
      const dash = '';
      const pdf = '.pdf';
      const d = new Date();
      let year = this.thisYear;
      const fn = 'f1120sfor';
      const fl = fn.concat(year, dash, pdf);
      const emp = '1';
      const str1 = '/api/v2/pim/employees/';
      const str2 = '/screen/personal/attachments';
      const str = str1.concat(emp, str2);
      const sfiles = new APIService(window.appGlobal.baseUrl, str);
      sfiles.getAll().then((response) => {
        let dat = response.data;
        const fle = dat.data.find((f) => f.filename === fl);
        if (fle) {
          //console.log(fle);
          let id = fle.id;
          const downUrl = `${window.appGlobal.baseUrl}/pim/viewAttachment/empNumber/1/attachId/${id}`;
          window.open(downUrl, '_blank');
        }
      });
    },
    async resetDataTable() {
      await this.execQuery();
    },
  },
};
</script>
